import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/featureGroup/license.featureGroup.delete.mutation.gql"
import type {
  FeatureGroupDeleteMutation,
  FeatureGroupDeleteMutationVariables,
} from "@/v2-backoffice-client/license/featureGroup/__types__/license.featureGroup.delete.mutation"

type Options = MutationHookOptions<
  FeatureGroupDeleteMutation,
  FeatureGroupDeleteMutationVariables
>

export function useFeatureGroupDeleteMutation(options?: Options) {
  return useMutation<
    FeatureGroupDeleteMutation,
    FeatureGroupDeleteMutationVariables
  >(mutation, options)
}
